import { useUserContext } from 'common/contexts/UserContext';
import { useRegion } from 'common/hooks/region';
import * as React from 'react';
import { checkCredentialsForRegion } from 'services/clients/credentials';

/**
 * Helper hook for determining if we show the credentials valid banner
 * @returns true if all credentials are entered and valid
 */
export const useHasValidCredentials = () => {
  const region = useRegion();
  const { user } = useUserContext();

  const [allCredentialsEnteredAndValid, setAllCredentialsEnteredAndValid] =
    React.useState<boolean>(true);

  React.useEffect(() => {
    const fetch = async () => {
      const valid = await checkCredentialsForRegion(region);
      setAllCredentialsEnteredAndValid(valid);
    };
    fetch();
  }, [user, region]);

  return allCredentialsEnteredAndValid;
};
